export const SET_FOOTER = 'SET_FOOTER';
export const SET_PAGE = 'SET_PAGE';
